<template>
  <v-container>
    <v-dialog v-model="estadoComp" persistent fullscreen>
      <!-- stlye="overflow: hidden !important;" -->
      <v-card tabindex="0" v-on:keyup.enter="eventDiapositiva('next')" v-on:keyup.down="eventDiapositiva('next')"
        v-on:keyup.right="eventDiapositiva('next')" v-on:keyup.up="eventDiapositiva('back')"
        v-on:keyup.left="eventDiapositiva('back')" @keyup="detectaPuntero">
        <v-card-title class="px-0 py-1" style="border-bottom: 1.5px solid rgb(206, 206, 206)">
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-if="mostrarBotonParticipacion == true" @click="mostrarParticipacion" fab dark x-small
                class="mx-1 btn_editar white--text" v-on="on">
                <v-icon dark>fa-users</v-icon>
              </v-btn>
            </template>
            <span>Participación</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="fullWindows = !fullWindows" fab dark x-small class="mx-1 btn_block_style2" v-on="on">
                <v-icon dark>{{
                  fullWindows ? "far fa-images" : "fa-solid fa-tv"
                }}</v-icon>
              </v-btn>
            </template>
            <span class="text-center">{{
              fullWindows ? "Mostrar miniaturas" : "Vista completa"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab dark x-small class="mx-1 btn_style3" @click="cerrarModal" v-on="on">
                <v-icon dark>fa-times</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-0 ma-0">
          <v-row class="pa-0 ma-0">
            <!-- CUANDO ESTÉ CARGANDO( AUN NO TRAE LA DATA) -->
            <template v-if="loading">
              <!-- animación de carga aquí -->
              <v-col cols="12" class="mt-16 text-center">
                <v-progress-circular indeterminate :size="100" :width="7" color="blue">
                </v-progress-circular>
                <br />
                <h3 class="mt-8">Cargando contenido...</h3>
              </v-col>
            </template>

            <!-- CUANDO LA DATA YA SE HAYA TRAIDO Y  NO ES PANTALLA COMPLETA -->
            <template v-else-if="!fullWindows">
              <!-- ESTAS SON LAS PEQUEÑAS VISTAS ENUMERADAS DE LAS VISTAS QUE   APARECEN DEL LADO IZQUIERDO style="max-height: 93vh" :style="maxH" style="background: blue;"-->
              <v-col cols="3" sm="2" class="pa-2 overflow-y-auto custom-scroll" :style="{ 'max-height': Heightmax }">
                <v-card class="cardMiniatura my-3" :class="item.id == idDiapositiva.id ? 'classP' : ''" :id="index + 1"
                  v-for="(item, index) of data" :key="index" @click="loadDiapositiva(item, index)" :ref="item.id">
                  <v-card-title class="pa-0 ma-0">
                    <v-row no-gutters align="center" class="px-1">
                      <!-- ESTE PRIMER V-COL ES PARA LE NÚMERO DENTRO DEL CIRCULO -->
                      <v-col cols="auto" class="">
                        <v-avatar color="primary" size="26" class="d-flex align-center justify-center">
                          <span class="white--text">{{ index + 1 }} </span>
                        </v-avatar>
                      </v-col>
                      <v-col class="text-center">
                        <span v-if="item.titulo != null" v-html="item.titulo.replace(/(<([^>]+)>)/gi, '')"
                          class="font-weight-black" style="font-size: 12px">
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 ma-0">
                    <v-img v-if="item.tipo === 'DS'" :src="URL_SPACE + item.diapositiva.uri + cacheDinamica"
                      :lazy-src="item.diapositiva.uri" class="white--text align-end imagen">
                      <template v-slot:placeholder>
                        <div class="d-flex align-center justify-center fill-height">
                          <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
                        </div>
                      </template>
                    </v-img>

                    <v-img v-else :src="`@/assets/iconos/${extTipoItem[item.tipo]}`"
                      class="white--text align-end imagen">
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-col>
              <!-- ESTA ES LA COLUMNO DE LA DIAPOSITIVA CUANDO SE ESTÁ EN TAMAÑO NORMAL (DEL LADO DERECHO) id="contenedorScreen"-->
              <v-col cols="9" sm="10" class="pa-0 ma-0 contenido_lienzo" ref="contenedorScreen">
                <component :is="nombreComp" :presentacion="diapost" :preguntas="pregunta" :respuestaVerdadera="rv"
                  :respuestaUnica="ru" :respuestas="rm" @comprobar="validarRespuesta" :opciones="opcs" :validar="valid"
                  :screen="screen" :fullWindows="fullWindows" :key="indexDiapositiva"
                  @eventDiapositiva="eventDiapositiva">
                </component>
              </v-col>
            </template>

            <!-- CUANDO ESTÁ EN MODO PANTALLA COMPLETA  -->
            <!-- ESTA ES LA COLUMNO DE LA DIAPOSITIVA CUANDO SE ESTÁ EN PANTALLA COMPLETA (OCUPAN TODA LA PATALLA) -->
            <!-- pa-0 ma-0 contenido_lienzo -->
            <template v-else>
              <v-col cols="12" class="" id="contenedorScreen" ref="contenedorScreen">
                <transition :name="transitionName">
                  <component :is="nombreComp" :presentacion="diapost" :fullWindows="fullWindows"
                    :screenDocument="screenDocument" :key="indexDiapositiva">
                  </component>
                </transition>
              </v-col>
            </template>

          </v-row>
        </v-card-text>
        <!-- :key="indexDiapositiva + 100" -->
        <!-- Esto debió quitarse??????   :screen="screen" 
                <template v-if="parametros.miniatura && !diapost.uri"> 
                    <v-card-actions style="border: 3px solid cyan ">
                    <v-row >
                        <v-col>
                            <v-btn class="btn_block_style2"  @click="loadScreen('contenedorScreen')" :disabled="screen">Generar CAPTURA DE PANTALLA</v-btn>   
                        </v-col>
                    </v-row>
                    </v-card-actions>
                </template> -->
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="screen" persistent scrollable max-width="60%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Referencia de creación de miniatura
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" v-if="parametros.miniatura">
              <v-row justify="center">
                <v-col cols="12" v-if="imgTemp">
                  <v-img :src="imgTemp" id="imgTemp" max-width="300" max-height="300" class="mx-auto"></v-img>
                </v-col>

                <v-col cols="12" v-else class="d-flex justify-center">
                  <v-progress-circular :size="100" :width="10" indeterminate color="primary">
                    {{ value }}
                  </v-progress-circular>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
      </v-card>
    </v-dialog> -->

    <!-- videojs
            Este div se usa ara cargar los videos de las diapositivas en la presentacion,
            se usa en este compoennte para que se mantenga oculto tras la modal de presentacion 
        -->
    <div id="videoPlayer"></div>
    <!-- videojs -->
  </v-container>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios"; //API_URL
import { mapMutations } from "vuex";
import VistaCol01 from "@/views/Manager/GestionContenido/viewGC/componentes/VistaCol01.vue";
import VistaCol02 from "@/views/Manager/GestionContenido/viewGC/componentes/VistaCol02.vue";
import VistaCol03 from "@/views/Manager/GestionContenido/viewGC/componentes/VistaCol03.vue";
import VistaPreg from "@/views/Manager/GestionContenido/viewGC/componentes/VistaPre1.vue";
import VistaDiapositiva from "@/views/Manager/GestionContenido/viewGC/componentes/VistaDiapositiva.vue";
import html2canvas from "html2canvas";
import canvas2Image from "canvas2image-2";
// import Template from '../template/template.vue';

export default {
  name: "VisorContenido",

  props: ["estadoComp", "parametros", "evento", "mostrarBotonParticipacion"],
  components: {
    VistaCol01,
    VistaCol02,
    VistaCol03,
    VistaPreg,
    VistaDiapositiva,
    //     Template
  },

  data() {
    return {
      screenDocument: true,
      data: [],
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      visor: false,
      nombreComp: "",
      rv: false,
      ru: false,
      rm: false,
      opcs: false,
      valid: true,
      screen: false,
      fullWindows: false,
      value: "",

      indexDiapositiva: -1,
      idDiapositiva: -1,
      diapost: [],
      pregunta: [],

      tempImgCanvas: Object,
      cropping: false,
      imgTemp: "",
      imgBLOB: "",

      transitionName: "",
      transitionEfectos: ["zoom"], //, "slideUp""fade", "fadeUp", 

      jsonOUT: {},
      jsonEND: {},

      extTipoItem: {
        PU: "PU.svg",
        PM: "PM.svg",
        PV: "VF.svg",
        C1: "1-COL.jpg",
        C2: "2-COL.jpg",
        C3: "3-COL.jpg",
        C4: "4-COL.jpg",
      },
      loading: true, //animación de carga
      Heightmax: 0,
    };
  },

  watch: {
    // activar o inactivar al modal
    estadoComp() {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        // this.parametros = {}
        // this.limpiarForm()                }
      }
    },
  },
  computed: {
    cacheDinamica() {
      const tm = new Date().getTime();
      return `?nocache=${tm}`;
    },
  },

  mounted() {
    this.loadMain();
    // Escuchar el evento de cambio de pantalla completa


  },
  beforeDestroy() {
    // Quitar los escuchadores de eventos cuando el componente se destruye
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);

  },
  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    detectaPuntero(event) {
      if (event.keyCode == 33 || event.key === 'PageUp') {
        this.eventDiapositiva('back')
      } else if (event.keyCode == 34 || event.key === 'PageDown') {
        this.eventDiapositiva('next');
      } else if (event.keyCode == 122 || event.key === 'F11') {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
        } else {
          document.exitFullscreen();
        }
      }
    },
    // Método para manejar el cambio de estado de pantalla completa
    handleFullscreenChange() {
      if (document.fullscreenElement) {
        this.Heightmax = window.innerHeight - 70 + 'px';
        this.screenDocument = true;
      } else {
        this.screenDocument = false;
        this.Heightmax = window.innerHeight - 70 + 'px';
      }
    },
    async loadMain() {
      document.getElementById("videoPlayer").innerHTML = "";
      this.fullWindows = false;
      this.data.splice(0);
      this.loading = true;
      await this.getData(this.parametros);
      this.loading = false; //Apagamos la animación de carga
      document.addEventListener('fullscreenchange', this.handleFullscreenChange);

    },
    async getData(item) {
      // EL CONTENIDO DEBE DEPENDE SOBRE EL TIPO que se desee obtener, puede ser del manager o del colegio
      const URI_CONTENIDO =
        item.tipo_contenido == "manager" || item.tipo_contenido == 1
          ? `/manager/contenido/list/${item.id_clase}`
          : `/administrativo/contenido/listarClase/${item.id_clase}`;
      try {
        const { success } = this.$states;
        await axios.get(URI_CONTENIDO).then(({ data }) => {
          if (
            data.messageT == success &&
            Object.keys(data.payload).length > 0
          ) {
            this.data = data.payload;
            this.startDiapositiva(this.data);
            this.openFullScreen();
          } else {
            this.data = [];
            this.setEnviarMens({
              tipo: "W",
              mensaje: "Aún no existen diapositivas creadas.",
              tiempo: 8000,
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async startDiapositiva(data) {
      //this.$refs.elementFocus.focus() // ref="elementFocus"
      let index = 0;
      // this.loadDiapositiva(data[index], index)
      await this.crearMiniatura(data);

      if (this.parametros.guardarMiniatura) {
        // open in end miniatura
        index = data.length - 1;

        const datosDiapositiva = data[index];
        await this.loadDiapositiva(datosDiapositiva, index);
        // let vf = this; // acceso a vue
        // setTimeout(function () {
        //   vf.loadScreen("contenedorScreen");
        // }, 1500);
      } else {
        this.loadDiapositiva(data[index], index);
      }
    },

    crearMiniatura(data) {

      if (this.parametros.miniatura) {
        // this.parametros.id_diapositiva = 27190  // primera
        // this.parametros.id_diapositiva = 43860

        for (const [key, value] of Object.entries(data)) {

          if (value.id == this.parametros.id_diapositiva) {
            this.loadDiapositiva(value, key);
            this.loadScreen("contenedorScreen");
          }

        }
      }
    },

    loadComponente() {
      let error = true;
      this.nombreComp = "VistaDiapositiva";
      error = false;
      return error;
    },

    loadDiapositiva(item, index) {

      if (this.indexDiapositiva != index) {
        this.nombreComp = null;
        this.indexDiapositiva = index;
        this.idDiapositiva = item;

        // document.location.href = `#${index - 1}`;

        const random = Math.floor(
          Math.random() * this.transitionEfectos.length
        );
        this.transitionName = this.transitionEfectos[random];

        this.getDiapositivaContenido(item);
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Ya estás en esta diapositiva.`,
          tiempo: null,
        });
      }
    },

    async getDiapositivaContenido(item) {
      this.diapost = item.diapositiva;
      this.screen = false;
      this.loadComponente();
    },

    /*************************** */
    validarRespuesta(tipo) {
      if (tipo === "prU") {
        this.ru = true;
      } else if (tipo === "prM") {
        this.rm = true;
        this.opcs = false;
        this.valid = false;
      }
    },
    /******* cerrar modal y blanquear arreglos */
    cerrarModal() {
      if (this.$route.params.value) {
        this.$router.push(`/alumnoClase/`);
      }

      this.$emit("close");
      this.closeFullScreen();
      document.documentElement.style.overflow = "auto";

      // this.estadoComp = false
      this.indexDiapositiva = -1;
      this.visor = false;
      this.diapost = [];
      this.pregunta = [];

      this.nombreComp = "";
    },
    mostrarParticipacion() {
      this.$emit("mostrarParticipacion");
    },

    validarEventDiapositiva(event) {
      if (this.data.length > 0) {
        const maxIndex = this.data.length;

        if (event == "next") {
          let indexNew = this.indexDiapositiva + 1;

          if (indexNew < maxIndex) {
            return indexNew;
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje: `Fin de Diapositivas (${maxIndex})`,
              tiempo: null,
            });
            return false;
          }
        }
        if (event == "back") {
          let indexNew = this.indexDiapositiva - 1;
          if (indexNew == -1) {
            this.setEnviarMens({
              tipo: "W",
              mensaje: `Ya esta en el inicio de la Diapositivas (1)`,
              tiempo: null,
            });
            return false;
          } else {
            return indexNew;
          }
        }
        return false;
      } else {
        return false;
      }
    },

    eventDiapositiva(event) {
      const indexNew = this.validarEventDiapositiva(event);
      if (typeof indexNew == "number") {
        const datosDiapositiva = this.data[indexNew];
        this.loadDiapositiva(datosDiapositiva, indexNew);
      }
    },

    openFullScreen() {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.msRequestFullscreen) {
        docElm = document.body; //overwrite the element (for IE)
        docElm.msRequestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    },

    closeFullScreen() {
      if (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },

    loadScreen(contScreen) {
      // actualiza la imagen preview del video
      this.screen = true;
      let vf = this; // acceso a vue
      setTimeout(function () {
        vf.captureScreen(contScreen);
      }, 4000);
    },

    async captureScreen(contScreen) {
      let cont = this.$refs[contScreen];

      let configCanvas = {
        allowTaint: true, // aceptar Imagenes
        useCORS: true, // permite exportar IMG
      };
      // crea un canvas temporal con el contenedor especificado
      await html2canvas(cont, configCanvas).then((temporalCanvas) => {
        // Captura solo para visualizar no sirve para mas nada..
        let img = canvas2Image.convertToPNG(temporalCanvas);
        this.imgTemp = img.src;

        let vf = this;

        // covierte el archivo de canvas a tipo BLOB para poder guardarlo
        temporalCanvas.toBlob(function (blob) {
          setTimeout(function () {
            vf.saveMiniatura(blob, vf.parametros);
          }, 2500);
        });
      });
    },

    async saveMiniatura(archivo, parametros) {
      this.setEnviarMens({
        tipo: "S",
        mensaje: `Guardar miniatura `,
        tiempo: null,
      });

      try {
        let formData = new FormData();
        formData.append("subirArchivo", archivo);

        formData.append("id_nivel", parametros.id_adm_nivel);
        formData.append("id_grado", parametros.id_grado);
        formData.append("id_area", parametros.id_adm_area);
        formData.append("id_tema", parametros.id_tema);
        formData.append("id_curso", parametros.id_curso);
        formData.append("id_clase", parametros.id_clase);

        let response = await axios.post("/archivo/miniaturaAdd", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        let res = response.data;
        let vm = this;
        setTimeout(function () {
          vm.screen = false;
          vm.imgTemp = "";
        }, 3000);

        if (res.messageT == "S") {
          this.saveItem(this.idDiapositiva, res);
        } else {
          this.setEnviarMens({
            tipo: res.messageT,
            mensaje: res.message,
            tiempo: 5000,
          });
        }
      } catch {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error en cargar archivo en el Servidor`,
          tiempo: 5000,
        });
        this.screen = false;
        this.imgTemp = "";
        return false;
      }
    },

    async saveItem(itemDiapositiva, datosMiniatura) {
      try {
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Actualizando miniatura`,
          tiempo: 5000,
        });
        this.jsonOUT = "ENTRO EN GUARDAR";

        let miniatura = {
          id_usuario: sessionStorage.id,
          miniatura_ruta: datosMiniatura.rutaDestino,
          miniatura_archivo: datosMiniatura.nombreArchivo,
        };

        this.jsonOUT = miniatura;

        await axios.put(
          `/manager/contenido/miniatura/${itemDiapositiva.id}`,
          miniatura
        );
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error en cargar archivo en el Servidor`,
          tiempo: 5000,
        });
        return false;
      }
    },
  },
};
</script>

<!-- <style scoped>
.classP {
  border-color: #ffbc00;
  transition: 0.3s;
  border-width: 3px;
  border-style: solid;
}

.canvas {
  border: 2px solid #d9d9d9;
}

.cardMiniatura {
  max-height: 200px;
  overflow: hidden;
}


</style> -->
<style>
.classP {
  border-color: #ffbc00 !important;
  transition: 0.3s;
  border-width: 3px;
  border-style: solid;
}

.contenido_lienzo {
  background-color: whitesmoke;
}

.v-dialog .v-ripple__container {
  display: none !important;
}

#contenedorScreen {
  background-color: white;
}
</style>